import { useState, type FormEvent } from "react";
import { ApiError, api } from "./api";
import { errorKey, useT } from "./i18n";

const MIN = 10;

export default function ChangePassword() {
  const t = useT();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (next !== repeat) {
      setError(t("reset.mismatch"));
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.changePassword(current, next);
      setNotice(t("settings.changed"));
      setCurrent("");
      setNext("");
      setRepeat("");
    } catch (err) {
      setError(t(err instanceof ApiError ? errorKey(err.code) : "error.password_change_failed"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="rounded border border-current/20 p-5">
      <h2 className="text-xs font-semibold uppercase tracking-widest opacity-60">
        {t("settings.password")}
      </h2>

      <form onSubmit={submit} className="mt-4 flex max-w-sm flex-col gap-3">
        <label className="flex flex-col gap-1.5">
          <span className="text-sm opacity-70">{t("settings.current")}</span>
          <input
            type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
            required autoComplete="current-password"
            className="rounded border border-current/25 bg-transparent px-3 py-2"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-sm opacity-70">{t("settings.new")}</span>
          <input
            type="password" value={next} onChange={(e) => setNext(e.target.value)}
            required minLength={MIN} autoComplete="new-password"
            className="rounded border border-current/25 bg-transparent px-3 py-2"
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-sm opacity-70">{t("reset.confirm")}</span>
          <input
            type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)}
            required minLength={MIN} autoComplete="new-password"
            className="rounded border border-current/25 bg-transparent px-3 py-2"
          />
        </label>

        {error && <p role="alert" className="text-[var(--color-bad)]">{error}</p>}
        {notice && <p className="text-[var(--color-accent)]">{notice}</p>}

        <button
          type="submit" disabled={busy}
          className="mt-1 self-start rounded bg-[var(--color-accent)] px-5 py-2.5 font-semibold text-white disabled:opacity-50"
        >
          {t(busy ? "settings.changing" : "settings.change")}
        </button>
      </form>
    </section>
  );
}
